import React from "react";
import Slider from "react-slick";
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Divider from '@mui/material/Divider';
import { API_URL, APP_URL } from "../../../Config/index";
import axios from 'axios';
import { useEffect } from "react";
import { useState } from "react";

const allcate = [
    {
        itemsimg: './img/img11.png',
        itemsimgtwo: './img/pht2.png',
        itemsimgthree: './img/pht3.png',
        itemsimgfour: './img/pht4.png',
        textheading: 'Rohit Kumar Saini For Sikar',
        textstock: ' Owner',
        proimg: './img/pht1.png',
        tokenprice: 'Price',
        tokenpricetwo: '1.0 MATIC',
        textview: 'Avid Lines',
        btnbid: '18 items'
    },
    {
        itemsimg: './img/phtimg1.png',
        itemsimgtwo: './img/pht3.png',
        itemsimgthree: './img/pht1.png',
        itemsimgfour: './img/pht2.png',
        textheading: 'Rajaram for jaipur',
        textstock: ' Owner ',
        proimg: './img/pht4.png',
        proimg: './img/card-item8.jpg',
        tokenprice: 'Price',
        tokenpricetwo: '2.00 ETH',
        textview: 'FoxFam',
        btnbid: '35 items'
    },
    {
        itemsimg: './img/img13.png',
        itemsimgtwo: './img/pht4.png',
        itemsimgthree: './img/pht1.png',
        itemsimgfour: './img/pht2.png',
        textheading: 'Tarun kumar for jaipur',
        textstock: 'Owner',
        tokenprice: 'Price',
        proimg: './img/pht2.png',
        tokenpricetwo: '4.02 BNB',
        textview: 'PhantaBear',
        btnbid: '45 items'
    },
    {

        itemsimg: './img/img12.png',
        itemsimgtwo: './img/pht1.png',
        itemsimgthree: './img/pht4.png',
        itemsimgfour: './img/pht3.png',
        textheading: 'Dodo hide the seek',
        textstock: ' Owner',
        proimg: './img/pht4.png',
        tokenprice: 'Price',
        tokenpricetwo: '2.00 ETH',
        textview: 'Lucky Zeros',
        btnbid: '55 items'
    },
    {
        itemsimg: './img/img13.png',
        itemsimgtwo: './img/pht1.png',
        itemsimgthree: './img/pht3.png',
        itemsimgfour: './img/pht4.png',
        textheading: 'Synthwave Painting',
        textstock: ' Owner',
        proimg: './img/pht2.png',
        tokenprice: 'Price',
        tokenpricetwo: '2.11 MATIC',
        textview: 'Doodles',
        btnbid: '69 items'
    },
]



const Categoriespage = () => {
    const [category,setcategory]=useState();

    const fetchcategory= async()=>{

        return await axios.get(`${API_URL}/indexData.php?type=category`, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(res => {
            setcategory(res.data);
          })
    }

    useEffect(()=>{
        fetchcategory();
    },[])

    var settings = {
        dots: false,
        arrows: true,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]

    };

    return (
         
            <Box className="categry" paddingY='2rem'>
                <Container maxWidth='xl'>
                    <Typography variant="h2" gutterBottom component='h2'  color='#000' fontSize='45px' fontWeight='bold'>
                        Category
                    </Typography>
                    <Slider {...settings}>
                        {category && category.map((token, index) => ( 
                            <Box key={index} className="categry_inner">
                                <Box>
                                    <Link to={`/Categoriesdetails/${token.category_name}`}>
                                        <img className='pht_maining' src={APP_URL+'/'+token.category_image} alt='' width='100%' />
                                    </Link> 
                                </Box> 
                                <Box className="card-title">
                                    <Box>
                                        <Link to='/'>
                                            <Typography variant="body" component='body' >
                                                {token.category_name}
                                            </Typography>
                                        </Link>
                                    </Box> 
                                </Box>
                            </Box> 
                        ))}
                    </Slider>
                </Container>
            </Box>
         
    )
}

export default Categoriespage;  